import { render } from "./ChangeForgetPassword.vue?vue&type=template&id=0e0f8736&scoped=true"
import script from "./ChangeForgetPassword.vue?vue&type=script&lang=js"
export * from "./ChangeForgetPassword.vue?vue&type=script&lang=js"

import "./ChangeForgetPassword.vue?vue&type=style&index=0&id=0e0f8736&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e0f8736"]])

export default __exports__